import { render, staticRenderFns } from "./CreateGrade.vue?vue&type=template&id=47c14926&scoped=true"
import script from "./CreateGrade.vue?vue&type=script&lang=js"
export * from "./CreateGrade.vue?vue&type=script&lang=js"
import style0 from "./CreateGrade.vue?vue&type=style&index=0&id=47c14926&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c14926",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47c14926')) {
      api.createRecord('47c14926', component.options)
    } else {
      api.reload('47c14926', component.options)
    }
    module.hot.accept("./CreateGrade.vue?vue&type=template&id=47c14926&scoped=true", function () {
      api.rerender('47c14926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/GradeDialog/CreateGrade.vue"
export default component.exports